
import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/components/dashboard/DashboardLayout';
import { useAuth } from '@/context/SupabaseAuthContext';
import BackToDashboardButton from '@/components/navigation/BackToDashboardButton';
import PayoutReport from '@/components/reports/PayoutReport';

const PayoutReportPage = () => {
  const navigate = useNavigate();
  const { logoutUser } = useAuth();
  
  return (
    <DashboardLayout onLogout={logoutUser}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <BackToDashboardButton />
        
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Payout Reports</h1>
          <p className="text-gray-600">View your payout history and upcoming payments</p>
        </div>
        
        <PayoutReport />
      </div>
    </DashboardLayout>
  );
};

export default PayoutReportPage;
